import axios from "axios";

const getArticulosTotem = async searchString => {
  const formattedNic = localStorage.getItem("formattedNic");
  const puesto = JSON.parse(localStorage.getItem("puesto"));
  const token = localStorage.getItem("token");
  const idPuesto = puesto.idPuesto;
  const userData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
    idPuesto: idPuesto,
    pageNumber: 1,
    searchString: searchString,
  };

  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Catalogo/BuscarArticulosTotemPorPuesto`, userData);
  return response;
};

const articulosTotem = {
  getArticulosTotem,
};

export default articulosTotem;
